var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResultRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_3627",
    "data-name": "Grupo 3627",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 250.243,
    height: 257.459,
    viewBox: "0 0 250.243 257.459",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2600",
    "data-name": "Rect\\xE1ngulo 2600",
    width: 250.243,
    height: 257.459,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2644",
    "data-name": "Rect\\xE1ngulo 2644",
    width: 215.69,
    height: 215.69,
    rx: 107.845,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2647",
    "data-name": "Rect\\xE1ngulo 2647",
    width: 27.03,
    height: 52.098,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4704",
    "data-name": "Trazado 4704",
    d: "M97.194,140.448v1.614a9.416,9.416,0,1,1-18.832,0v-1.49l-29.293,4.519A14.543,14.543,0,0,0,37.086,162.6l10.433,47.26a8.057,8.057,0,0,0,10.853,5.746l-.277,14.421h64.865l-6.893-36.979,26.979,5.587c13.623,2.821,22.932-13.4,13.624-23.739l-21.739-24.15a21.78,21.78,0,0,0-13.12-6.993l-23.862-3.308Z",
    transform: "translate(-36.74 -140.447)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3614",
    "data-name": "Grupo 3614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3613",
    "data-name": "Grupo 3613",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4653",
    "data-name": "Trazado 4653",
    d: "M150.927,21.1H116.439a90.6,90.6,0,0,0-90.6,90.6v34.489a90.6,90.6,0,0,0,90.6,90.6h34.489a90.6,90.6,0,0,0,90.6-90.6V111.7a90.6,90.6,0,0,0-90.6-90.6",
    transform: "translate(-9.581 -7.826)",
    fill: "#ffc8bf"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3616",
    "data-name": "Grupo 3616",
    transform: "translate(16.256 12.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3615",
    "data-name": "Grupo 3615",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2601",
    "data-name": "Rect\\xE1ngulo 2601",
    width: 244.151,
    height: 54.827,
    transform: "translate(-12.551 189.715)",
    fill: "#ff7b72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4654",
    "data-name": "Trazado 4654",
    d: "M186.44,165.6h66.493a1.415,1.415,0,0,0,1.416-1.415h0V118.162a1.415,1.415,0,0,0-1.415-1.416H186.44a1.415,1.415,0,0,0-1.416,1.415h0v46.024a1.415,1.415,0,0,0,1.415,1.416h0",
    transform: "translate(-84.868 -56.21)",
    fill: "#ffe2e0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_189",
    "data-name": "L\\xEDnea 189",
    x1: 11.716,
    y2: 10.136,
    transform: "translate(168.953 51.206)",
    fill: "none",
    stroke: "#ff7e7c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4655",
    "data-name": "Trazado 4655",
    d: "M50.732,165.6h66.493a1.415,1.415,0,0,0,1.416-1.415h0V118.162a1.415,1.415,0,0,0-1.415-1.416H50.732a1.415,1.415,0,0,0-1.416,1.415h0v46.024a1.415,1.415,0,0,0,1.415,1.416h0",
    transform: "translate(-34.544 -56.21)",
    fill: "#ffe2e0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_190",
    "data-name": "L\\xEDnea 190",
    x1: 11.716,
    y2: 10.136,
    transform: "translate(83.57 51.206)",
    fill: "none",
    stroke: "#ff7e7c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4656",
    "data-name": "Trazado 4656",
    d: "M.55,165.6H12.519a1.415,1.415,0,0,0,1.416-1.415h0V118.162a1.415,1.415,0,0,0-1.415-1.416H.55Z",
    transform: "translate(-16.46 -56.21)",
    fill: "#ffe2e0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_191",
    "data-name": "L\\xEDnea 191",
    x1: 11.716,
    y2: 10.136,
    transform: "translate(-3.052 51.206)",
    fill: "none",
    stroke: "#ff7e7c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4657",
    "data-name": "Trazado 4657",
    d: "M.55,264.732H12.519a1.415,1.415,0,0,0,1.416-1.415h0V217.292a1.415,1.415,0,0,0-1.415-1.416H.55Z",
    transform: "translate(-16.46 -92.97)",
    fill: "#ffe2e0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_192",
    "data-name": "L\\xEDnea 192",
    x1: 11.716,
    y2: 10.136,
    transform: "translate(-3.052 113.576)",
    fill: "none",
    stroke: "#ff7e7c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4658",
    "data-name": "Trazado 4658",
    d: "M186.44,264.732h66.493a1.415,1.415,0,0,0,1.416-1.415h0V217.292a1.415,1.415,0,0,0-1.415-1.416H186.44a1.415,1.415,0,0,0-1.416,1.415h0v46.023a1.415,1.415,0,0,0,1.415,1.416Z",
    transform: "translate(-84.868 -92.97)",
    fill: "#ffe2e0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_193",
    "data-name": "L\\xEDnea 193",
    x1: 11.716,
    y2: 10.136,
    transform: "translate(168.953 113.576)",
    fill: "none",
    stroke: "#ff7e7c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4659",
    "data-name": "Trazado 4659",
    d: "M50.312,264.732H116.8a1.415,1.415,0,0,0,1.416-1.415h0V217.292a1.415,1.415,0,0,0-1.415-1.416H50.312a1.415,1.415,0,0,0-1.416,1.415h0v46.023a1.415,1.415,0,0,0,1.415,1.416Z",
    transform: "translate(-34.388 -92.97)",
    fill: "#ffe2e0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_194",
    "data-name": "L\\xEDnea 194",
    x1: 11.716,
    y2: 10.136,
    transform: "translate(83.306 113.576)",
    fill: "none",
    stroke: "#ff7e7c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4660",
    "data-name": "Trazado 4660",
    d: "M201.786,237.856H1V94.988H198.245a3.54,3.54,0,0,1,3.54,3.54Z",
    transform: "translate(-16.627 -48.141)",
    fill: "none",
    stroke: "#ff7e7c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2602",
    "data-name": "Rect\\xE1ngulo 2602",
    width: 81.041,
    height: 58.992,
    rx: 2,
    transform: "translate(100.156 50.4)",
    fill: "none",
    stroke: "#ff7e7c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2603",
    "data-name": "Rect\\xE1ngulo 2603",
    width: 81.041,
    height: 58.992,
    rx: 4,
    transform: "translate(100.156 113.173)",
    fill: "none",
    stroke: "#ff7e7c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2604",
    "data-name": "Rect\\xE1ngulo 2604",
    width: 81.041,
    height: 58.992,
    rx: 4,
    transform: "translate(14.509 50.4)",
    fill: "none",
    stroke: "#ff7e7c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2605",
    "data-name": "Rect\\xE1ngulo 2605",
    width: 81.041,
    height: 58.992,
    rx: 4,
    transform: "translate(14.509 113.173)",
    fill: "none",
    stroke: "#ff7e7c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2606",
    "data-name": "Rect\\xE1ngulo 2606",
    width: 25.529,
    height: 58.992,
    rx: 4,
    transform: "translate(-15.627 50.4)",
    fill: "none",
    stroke: "#ff7e7c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2607",
    "data-name": "Rect\\xE1ngulo 2607",
    width: 25.529,
    height: 58.992,
    rx: 4,
    transform: "translate(-15.627 113.173)",
    fill: "none",
    stroke: "#ff7e7c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2608",
    "data-name": "Rect\\xE1ngulo 2608",
    width: 29.496,
    height: 29.496,
    transform: "translate(17.692 79.896)",
    fill: "#ffc5bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2609",
    "data-name": "Rect\\xE1ngulo 2609",
    width: 29.496,
    height: 29.496,
    transform: "translate(17.692 79.896)",
    fill: "none",
    stroke: "#e79a9d",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2610",
    "data-name": "Rect\\xE1ngulo 2610",
    width: 11.113,
    height: 4.159,
    transform: "translate(30.863 86.349)",
    fill: "#a64544"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4661",
    "data-name": "Trazado 4661",
    d: "M66.5,158.667a4.09,4.09,0,1,1-4.09-4.09,4.089,4.089,0,0,1,4.09,4.09",
    transform: "translate(-37.883 -70.239)",
    fill: "#ff7e7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2611",
    "data-name": "Rect\\xE1ngulo 2611",
    width: 10.078,
    height: 36.543,
    transform: "matrix(0.992, -0.123, 0.123, 0.992, 47.889, 73.127)",
    fill: "#ffc5bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2612",
    "data-name": "Rect\\xE1ngulo 2612",
    width: 10.078,
    height: 36.543,
    transform: "matrix(0.992, -0.123, 0.123, 0.992, 47.889, 73.127)",
    fill: "none",
    stroke: "#e79a9d",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2613",
    "data-name": "Rect\\xE1ngulo 2613",
    width: 29.496,
    height: 25.751,
    transform: "translate(30.863 144.785)",
    fill: "#ffc5bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2614",
    "data-name": "Rect\\xE1ngulo 2614",
    width: 29.496,
    height: 25.751,
    transform: "translate(30.863 144.785)",
    fill: "none",
    stroke: "#e79a9d",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2615",
    "data-name": "Rect\\xE1ngulo 2615",
    width: 11.113,
    height: 4.159,
    transform: "translate(39.01 155.703)",
    fill: "#a64544"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4662",
    "data-name": "Trazado 4662",
    d: "M115.312,268.9a4.09,4.09,0,1,1-4.09-4.09,4.09,4.09,0,0,1,4.09,4.09",
    transform: "translate(-55.984 -111.115)",
    fill: "#ff7e7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2616",
    "data-name": "Rect\\xE1ngulo 2616",
    width: 29.496,
    height: 25.751,
    transform: "translate(101.782 144.908)",
    fill: "#ffc5bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2617",
    "data-name": "Rect\\xE1ngulo 2617",
    width: 29.496,
    height: 25.751,
    transform: "translate(101.782 144.908)",
    fill: "none",
    stroke: "#e79a9d",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2618",
    "data-name": "Rect\\xE1ngulo 2618",
    width: 11.113,
    height: 4.159,
    transform: "translate(109.93 155.824)",
    fill: "#a64544"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4663",
    "data-name": "Trazado 4663",
    d: "M228.037,269.092a4.09,4.09,0,1,1-4.09-4.09,4.089,4.089,0,0,1,4.09,4.09",
    transform: "translate(-97.786 -111.187)",
    fill: "#ff7e7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2619",
    "data-name": "Rect\\xE1ngulo 2619",
    width: 29.496,
    height: 21.127,
    transform: "translate(101.782 122.906)",
    fill: "#ffc5bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2620",
    "data-name": "Rect\\xE1ngulo 2620",
    width: 29.496,
    height: 21.127,
    transform: "translate(101.782 122.906)",
    fill: "none",
    stroke: "#e79a9d",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2621",
    "data-name": "Rect\\xE1ngulo 2621",
    width: 11.113,
    height: 4.159,
    transform: "translate(109.93 129.198)",
    fill: "#a64544"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4664",
    "data-name": "Trazado 4664",
    d: "M228.037,226.773a4.09,4.09,0,1,1-4.09-4.09,4.09,4.09,0,0,1,4.09,4.09",
    transform: "translate(-97.786 -95.494)",
    fill: "#ff7e7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2622",
    "data-name": "Rect\\xE1ngulo 2622",
    width: 29.496,
    height: 21.246,
    transform: "translate(137.542 149.309)",
    fill: "#ffc5bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2623",
    "data-name": "Rect\\xE1ngulo 2623",
    width: 29.496,
    height: 21.246,
    transform: "translate(137.542 149.309)",
    fill: "none",
    stroke: "#e79a9d",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2624",
    "data-name": "Rect\\xE1ngulo 2624",
    width: 11.113,
    height: 4.159,
    transform: "translate(145.69 155.72)",
    fill: "#a64544"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4665",
    "data-name": "Trazado 4665",
    d: "M284.874,268.927a4.09,4.09,0,1,1-4.09-4.09,4.09,4.09,0,0,1,4.09,4.09",
    transform: "translate(-118.863 -111.126)",
    fill: "#ff7e7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2625",
    "data-name": "Rect\\xE1ngulo 2625",
    width: 29.496,
    height: 21.246,
    transform: "translate(103.463 86.349)",
    fill: "#ffc5bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2626",
    "data-name": "Rect\\xE1ngulo 2626",
    width: 29.496,
    height: 21.246,
    transform: "translate(103.463 86.349)",
    fill: "none",
    stroke: "#e79a9d",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2627",
    "data-name": "Rect\\xE1ngulo 2627",
    width: 11.113,
    height: 4.159,
    transform: "translate(111.611 92.761)",
    fill: "#a64544"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4666",
    "data-name": "Trazado 4666",
    d: "M230.708,168.86a4.09,4.09,0,1,1-4.09-4.09,4.09,4.09,0,0,1,4.09,4.09",
    transform: "translate(-98.776 -74.018)",
    fill: "#ff7e7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2628",
    "data-name": "Rect\\xE1ngulo 2628",
    width: 7.968,
    height: 28.891,
    transform: "matrix(0.992, -0.123, 0.123, 0.992, 60.012, 141.874)",
    fill: "#ffc5bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2629",
    "data-name": "Rect\\xE1ngulo 2629",
    width: 7.968,
    height: 28.891,
    transform: "matrix(0.992, -0.123, 0.123, 0.992, 60.012, 141.874)",
    fill: "none",
    stroke: "#e79a9d",
    strokeWidth: 1.999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2630",
    "data-name": "Rect\\xE1ngulo 2630",
    width: 7.968,
    height: 28.891,
    transform: "matrix(0.992, -0.123, 0.123, 0.992, 69.246, 141.874)",
    fill: "#ffc5bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2631",
    "data-name": "Rect\\xE1ngulo 2631",
    width: 7.968,
    height: 28.891,
    transform: "matrix(0.992, -0.123, 0.123, 0.992, 69.246, 141.874)",
    fill: "none",
    stroke: "#e79a9d",
    strokeWidth: 1.999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2632",
    "data-name": "Rect\\xE1ngulo 2632",
    width: 7.971,
    height: 28.902,
    transform: "matrix(0.992, -0.123, 0.123, 0.992, 131.806, 119.619)",
    fill: "#ffc5bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2633",
    "data-name": "Rect\\xE1ngulo 2633",
    width: 7.971,
    height: 28.902,
    transform: "matrix(0.992, -0.123, 0.123, 0.992, 131.806, 119.619)",
    fill: "none",
    stroke: "#e79a9d",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2634",
    "data-name": "Rect\\xE1ngulo 2634",
    width: 7.971,
    height: 28.902,
    transform: "translate(140.818 119.508) rotate(-7.078)",
    fill: "#ffc5bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2635",
    "data-name": "Rect\\xE1ngulo 2635",
    width: 7.971,
    height: 28.902,
    transform: "translate(140.818 119.508) rotate(-7.078)",
    fill: "none",
    stroke: "#e79a9d",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2636",
    "data-name": "Rect\\xE1ngulo 2636",
    width: 7.971,
    height: 28.902,
    transform: "matrix(0.992, -0.123, 0.123, 0.992, 132.959, 78.967)",
    fill: "#ffc5bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2637",
    "data-name": "Rect\\xE1ngulo 2637",
    width: 7.971,
    height: 28.902,
    transform: "matrix(0.992, -0.123, 0.123, 0.992, 132.959, 78.967)",
    fill: "none",
    stroke: "#e79a9d",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2638",
    "data-name": "Rect\\xE1ngulo 2638",
    width: 7.971,
    height: 28.902,
    transform: "translate(141.97 78.855) rotate(-7.078)",
    fill: "#ffc5bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2639",
    "data-name": "Rect\\xE1ngulo 2639",
    width: 7.971,
    height: 28.902,
    transform: "translate(141.97 78.855) rotate(-7.078)",
    fill: "none",
    stroke: "#e79a9d",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2640",
    "data-name": "Rect\\xE1ngulo 2640",
    width: 7.971,
    height: 28.902,
    transform: "matrix(0.992, -0.123, 0.123, 0.992, 150.971, 78.725)",
    fill: "#ffc5bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2641",
    "data-name": "Rect\\xE1ngulo 2641",
    width: 7.971,
    height: 28.902,
    transform: "matrix(0.992, -0.123, 0.123, 0.992, 150.971, 78.725)",
    fill: "none",
    stroke: "#e79a9d",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2642",
    "data-name": "Rect\\xE1ngulo 2642",
    width: 7.971,
    height: 28.902,
    transform: "matrix(0.992, -0.123, 0.123, 0.992, 159.982, 78.614)",
    fill: "#ffc5bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2643",
    "data-name": "Rect\\xE1ngulo 2643",
    width: 7.971,
    height: 28.902,
    transform: "matrix(0.992, -0.123, 0.123, 0.992, 159.982, 78.614)",
    fill: "none",
    stroke: "#e79a9d",
    strokeWidth: 2
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3618",
    "data-name": "Grupo 3618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3617",
    "data-name": "Grupo 3617",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4667",
    "data-name": "Trazado 4667",
    d: "M10.212,108.264H51.2a7.409,7.409,0,0,1,7.41,7.407v18.67a7.408,7.408,0,0,1-7.41,7.407H10.212A7.409,7.409,0,0,1,2.8,134.341V115.673a7.409,7.409,0,0,1,7.408-7.409Z",
    transform: "translate(-1.039 -40.147)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2645",
    "data-name": "Rect\\xE1ngulo 2645",
    width: 55.806,
    height: 33.484,
    rx: 10.463,
    transform: "translate(1.763 68.117)",
    fill: "none",
    stroke: "#f47e6c",
    strokeWidth: 1.313
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4668",
    "data-name": "Trazado 4668",
    d: "M20.335,136.885l6.54-6.54,6.278,6.54,6.017-6.54,4.708,4.507,6.278-7.764,3.924,4.9",
    transform: "translate(-7.541 -47.128)",
    fill: "none",
    stroke: "#ff543b",
    strokeWidth: 3.94
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3620",
    "data-name": "Grupo 3620",
    transform: "translate(65 49.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3619",
    "data-name": "Grupo 3619",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4669",
    "data-name": "Trazado 4669",
    d: "M130.931,82.606V96.288a23.19,23.19,0,0,1-5.445,14.925,7.39,7.39,0,0,1-2.561,1.964l-.145.064V98.376H104.9V82.606Z",
    transform: "translate(-103.901 -80.121)",
    fill: "#ff9ea1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4670",
    "data-name": "Trazado 4670",
    d: "M130.341,78.655v2.486H104.312V96.91h-.985c-.011-.188-.016-.382-.016-.57V78.655Z",
    transform: "translate(-103.311 -78.656)",
    fill: "#ff9ea1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4671",
    "data-name": "Trazado 4671",
    d: "M122.191,125.382v6.688a9.44,9.44,0,0,1-18.88.008V107.67h.016a16.011,16.011,0,0,0,1.754,6.779c.048.151.1.3.151.452a16.286,16.286,0,0,0,2.658,4.826,15.721,15.721,0,0,0,12.294,5.929,7.382,7.382,0,0,0,2.007-.274",
    transform: "translate(-103.311 -89.415)",
    fill: "#ff9ea1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4672",
    "data-name": "Trazado 4672",
    d: "M123.234,126.532v2.847a7.431,7.431,0,0,1-2.007.274,15.727,15.727,0,0,1-12.294-5.929,16.3,16.3,0,0,1-2.658-4.826c-.054-.151-.1-.3-.151-.452a15.867,15.867,0,0,0,1.738,2.7l.108.13a15.588,15.588,0,0,0,12.208,5.891h.053a7.409,7.409,0,0,0,3-.635",
    transform: "translate(-104.354 -93.411)",
    fill: "#c26b6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4673",
    "data-name": "Trazado 4673",
    d: "M122.78,107.671v14.866a7.42,7.42,0,0,1-3,.635h-.053a15.591,15.591,0,0,1-12.208-5.892l-.108-.129a15.94,15.94,0,0,1-1.738-2.7,16.509,16.509,0,0,1-.769-4.977v-1.8Z",
    transform: "translate(-103.901 -89.416)",
    fill: "#ff9ea1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4674",
    "data-name": "Trazado 4674",
    d: "M105.09,114.45a16.013,16.013,0,0,1-1.754-6.779h.985v1.8a16.49,16.49,0,0,0,.769,4.977",
    transform: "translate(-103.32 -89.416)",
    fill: "#ff9ea1"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3622",
    "data-name": "Grupo 3622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3621",
    "data-name": "Grupo 3621",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4675",
    "data-name": "Trazado 4675",
    d: "M98.931,106.132c-.018-.476-.7-1.453-1.156-1.11a3.469,3.469,0,0,1-4.531-.5,5.409,5.409,0,0,1-1.743-4.035v-.639a3.652,3.652,0,0,1,.807-2.291c.1-.114.193-.221.284-.318a3.68,3.68,0,0,1,2.6-1.069c.112,0,.222.008.332.017a3.611,3.611,0,0,1,3.164,3.046,5.255,5.255,0,0,0,.43,1.446.351.351,0,0,0,.649-.035",
    transform: "translate(-33.931 -35.661)",
    fill: "#ff9ea1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4676",
    "data-name": "Trazado 4676",
    d: "M140.888,100.8a1.357,1.357,0,1,0-1.345,1.541,1.453,1.453,0,0,0,1.345-1.541",
    transform: "translate(-51.243 -36.942)",
    fill: "#471a4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4677",
    "data-name": "Trazado 4677",
    d: "M122.574,100.8a1.357,1.357,0,1,0-1.345,1.541,1.453,1.453,0,0,0,1.345-1.541",
    transform: "translate(-44.452 -36.942)",
    fill: "#471a4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4678",
    "data-name": "Trazado 4678",
    d: "M129.177,107.71h3.274a.407.407,0,0,0,.391-.528l-1.56-5.094",
    transform: "translate(-47.903 -37.857)",
    fill: "#fa9aab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4679",
    "data-name": "Trazado 4679",
    d: "M129.177,107.71h3.274a.407.407,0,0,0,.391-.528l-1.56-5.094",
    transform: "translate(-47.903 -37.857)",
    fill: "none",
    stroke: "#fd5c76",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4680",
    "data-name": "Trazado 4680",
    d: "M122.029,116.421a5.606,5.606,0,0,0,4.791,1.682",
    transform: "translate(-45.252 -43.172)",
    fill: "none",
    stroke: "#d43527",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4681",
    "data-name": "Trazado 4681",
    d: "M120.8,91.393c-.084-.474-1.647-.6-3.492-.272s-3.272.972-3.189,1.447Z",
    transform: "translate(-42.316 -33.723)",
    fill: "#470b4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4682",
    "data-name": "Trazado 4682",
    d: "M135.645,91.393c.084-.474,1.647-.6,3.492-.272s3.272.972,3.189,1.447Z",
    transform: "translate(-50.301 -33.723)",
    fill: "#470b4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4683",
    "data-name": "Trazado 4683",
    d: "M124.835,115.259l3.8.393c-.171,1.651-2.028,2.832-4.116,2.616s-3.666-1.752-3.5-3.4Z",
    transform: "translate(-44.876 -42.596)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4684",
    "data-name": "Trazado 4684",
    d: "M98.61,105.016c-.219-1.681-1.516-3.182-2.738-2.889",
    transform: "translate(-35.552 -37.858)",
    fill: "none",
    stroke: "#543822",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4685",
    "data-name": "Trazado 4685",
    d: "M134.127,78.747s-1.808,5.735-9.362,5.51c-7.57-.225-8.887-9.117-16.236-9.117v-1H134Z",
    transform: "translate(-40.246 -27.493)",
    fill: "#e58a8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4686",
    "data-name": "Trazado 4686",
    d: "M99.316,84.121a.377.377,0,0,1-.715.162,9.375,9.375,0,0,1-.758-3.447c-.044-.946-2.222-2.955-5.347-1.084-2.631-1.428-2.344-10.845-1.888-14.193.736-5.416,5.491-5.165,5.491-5.165s-.913-6.256,8.82-8.194c1.726-.343,10.959-1.328,10.793,7.64.608-5.922-3.621-7.14-7.361-9.465,6.412-3.155,21.918,4.317,19.315,10.24,2.368,1.217,2.325,4.436,2.018,7.283-.814,7.569-4.274,16.162-4.274,16.162V70.877s-1.071,1.436-5.927,1.436c-5.28,0-10.9-4.755-15.627-4.112-5.512.752-4.6,5.15-4.541,15.921",
    transform: "translate(-33.489 -18.403)",
    fill: "#1c133d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4687",
    "data-name": "Trazado 4687",
    d: "M100.769,110.19a3.1,3.1,0,0,1-1.233.559,34.931,34.931,0,0,0,2.375,3.894v-3.452c-.1-.5-.72-1.319-1.142-1",
    transform: "translate(-36.911 -40.835)",
    fill: "#1c133d"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3624",
    "data-name": "Grupo 3624",
    transform: "translate(23.116 88.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3623",
    "data-name": "Grupo 3623",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4688",
    "data-name": "Trazado 4688",
    d: "M156.669,174.9l-21.739-24.15a21.784,21.784,0,0,0-13.12-6.993l-23.862-3.308L79,140.476h-.016l-29.913,4.616A14.543,14.543,0,0,0,37.085,162.6l10.434,47.26a8.056,8.056,0,0,0,10.852,5.746l-.277,14.422h64.865l-6.893-36.979,26.979,5.587c13.623,2.821,22.932-13.4,13.624-23.739",
    transform: "translate(-36.74 -140.447)",
    fill: "#005cb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4689",
    "data-name": "Trazado 4689",
    d: "M157.812,261.873l8.978-.58-6.81-36.533-5.042,1.981Z",
    transform: "translate(-80.572 -171.713)",
    fill: "#dbe1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4690",
    "data-name": "Trazado 4690",
    d: "M100.63,202.16l-25.67,7.095-5.406-31.294,7.305-.458a10.534,10.534,0,0,1,11.171,11.174L87.149,202.7l6.728-1.771Z",
    transform: "translate(-48.909 -154.18)",
    fill: "#dbe1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4691",
    "data-name": "Trazado 4691",
    d: "M70.894,269.849l-.083,4.327H92.7L89.336,259.5Z",
    transform: "translate(-49.375 -184.596)",
    fill: "#dbe1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4692",
    "data-name": "Trazado 4692",
    d: "M87.9,240.08l1.439,6.275,39.752-22.3L71.006,246.608l-.2,10.142.083-.047.194-10.1Z",
    transform: "translate(-49.375 -171.45)",
    fill: "#1d3e71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4693",
    "data-name": "Trazado 4693",
    d: "M87.946,249.527l-16.81,6.528-.194,10.1L89.385,255.8Z",
    transform: "translate(-49.424 -180.897)",
    fill: "#5e97be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4694",
    "data-name": "Trazado 4694",
    d: "M167.889,187.725l-14.426-18.461-9.258.937a12.689,12.689,0,0,0-10.591,8.143l8.857-1.187-.775,6.075-8.9-.433c0,.01,0,.019,0,.03l-25.218-1.092.4,16.141,8,1.464-.488-14.861Z",
    transform: "translate(-63.007 -151.133)",
    fill: "#dbe1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4695",
    "data-name": "Trazado 4695",
    d: "M109.84,186.993l23.793,1.157a12.646,12.646,0,0,1,.821-4.455Z",
    transform: "translate(-63.848 -156.485)",
    fill: "#1d3e71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4696",
    "data-name": "Trazado 4696",
    d: "M157.335,181.809,148.478,183a12.649,12.649,0,0,0-.822,4.455l8.9.433Z",
    transform: "translate(-77.871 -155.785)",
    fill: "#5e97be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4697",
    "data-name": "Trazado 4697",
    d: "M71.435,243.662l57.58-22.617-34.44-6.3",
    transform: "translate(-49.606 -167.997)",
    fill: "none",
    stroke: "#001673",
    strokeLinejoin: "bevel",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4698",
    "data-name": "Trazado 4698",
    d: "M82.217,208.86l15.334-3.632-.4-16.141-17.688,6.994Z",
    transform: "translate(-52.582 -158.484)",
    fill: "#ffb9c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4699",
    "data-name": "Trazado 4699",
    d: "M183.29,188.921l-20.25-1.883a15.263,15.263,0,0,1,11.759-9.2l.555-.085Z",
    transform: "translate(-83.576 -154.283)",
    fill: "#ffb9c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4700",
    "data-name": "Trazado 4700",
    d: "M174.986,186.031c1.2-2.124,3.731-3.1,6.523-4.416",
    transform: "translate(-88.006 -155.713)",
    fill: "none",
    stroke: "#22022f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4701",
    "data-name": "Trazado 4701",
    d: "M178.992,190.05c1.127-1.89,3.37-3.073,5.81-4.394",
    transform: "translate(-89.491 -157.212)",
    fill: "none",
    stroke: "#22022f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4702",
    "data-name": "Trazado 4702",
    d: "M186.048,192.538c.654-1.16,1.852-1.8,3.27-2.636",
    transform: "translate(-92.108 -158.786)",
    fill: "none",
    stroke: "#22022f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_195",
    "data-name": "L\\xEDnea 195",
    x1: 7.936,
    y1: 11.164,
    transform: "translate(91.778 23.474)",
    fill: "none",
    stroke: "#22022f",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4703",
    "data-name": "Trazado 4703",
    d: "M107.573,184.24l34.124,1.5,1.24-9.719",
    transform: "translate(-63.007 -153.637)",
    fill: "none",
    stroke: "#001673",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_196",
    "data-name": "L\\xEDnea 196",
    x2: 5.243,
    y2: 24.297,
    transform: "translate(24.392 26.078)",
    fill: "none",
    stroke: "#001673",
    strokeWidth: 2
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3626",
    "data-name": "Grupo 3626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3625",
    "data-name": "Grupo 3625",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4705",
    "data-name": "Trazado 4705",
    d: "M130.214,282.825h-62l-7.529,51.023h78.644Z",
    transform: "translate(-22.505 -104.88)",
    fill: "#88889c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4706",
    "data-name": "Trazado 4706",
    d: "M128.51,344.191l2.507-27.288,9.538-4.267",
    transform: "translate(-47.655 -115.935)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4707",
    "data-name": "Trazado 4707",
    d: "M118.505,168.5l3.808-.376-3.645-15.814a.175.175,0,0,0-.178-.136l-3.961.138Z",
    transform: "translate(-42.471 -56.43)",
    fill: "#dbe1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4708",
    "data-name": "Trazado 4708",
    d: "M120.83,168.645h1.808c1.207,0,2.135.691,2.229-.525l2.1-10.241-2.8-5.715-2.155,1.08Z",
    transform: "translate(-44.807 -56.427)",
    fill: "#005cb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4709",
    "data-name": "Trazado 4709",
    d: "M111.151,146.219l-12.77-10.088-3.655,3.612,8.511,11.323c.351.406,2.839.848,3.021.343l4.942-5.01a.16.16,0,0,0-.05-.181",
    transform: "translate(-35.127 -50.481)",
    fill: "#2567b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4710",
    "data-name": "Trazado 4710",
    d: "M111.15,146.218,98.38,136.131l-3.655,3.612,8.511,11.323Z",
    transform: "translate(-35.127 -50.481)",
    fill: "#dbe1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4711",
    "data-name": "Trazado 4711",
    d: "M128.406,150.755l3.115-11.014-1.5-2.994-6.4,10.751,3.382,3.6a.827.827,0,0,0,1.4-.342",
    transform: "translate(-45.844 -50.71)",
    fill: "#2567b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4712",
    "data-name": "Trazado 4712",
    d: "M128.65,150.277l2.992-10.939-1.956-2.592-6.966,10.78Z",
    transform: "translate(-45.508 -50.71)",
    fill: "#dbe1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4713",
    "data-name": "Trazado 4713",
    d: "M119.355,162.141c.077.44.361.758.633.71s.43-.444.353-.883-.361-.758-.633-.71-.43.443-.353.883",
    transform: "translate(-44.253 -59.797)",
    fill: "#003765"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2649",
    "data-name": "Rect\\xE1ngulo 2649",
    width: 63.965,
    height: 4.375,
    transform: "translate(44.618 177.945)",
    fill: "#0f0f0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4714",
    "data-name": "Trazado 4714",
    d: "M84.819,294.907H79.57a2.836,2.836,0,0,1-2.836-2.836V280.392a2.836,2.836,0,0,1,2.836-2.836h5.249a2.836,2.836,0,0,1,2.836,2.836v11.679a2.837,2.837,0,0,1-2.836,2.836",
    transform: "translate(-28.455 -102.926)",
    fill: "#0f0f0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4715",
    "data-name": "Trazado 4715",
    d: "M354.393,52V26.285a13.052,13.052,0,0,0-6.691-11.4L323.985,1.654a13.051,13.051,0,0,0-12.719,0L287.548,14.886a13.052,13.052,0,0,0-6.691,11.4V52a13.051,13.051,0,0,0,6.691,11.4l23.718,13.235a13.054,13.054,0,0,0,12.719,0L347.7,63.393A13.052,13.052,0,0,0,354.393,52",
    transform: "translate(-104.15 0)",
    fill: "#ff584b"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_197",
    "data-name": "L\\xEDnea 197",
    x2: 28.466,
    transform: "translate(199.242 52.779)",
    fill: "none",
    stroke: "#fff6ec",
    strokeWidth: 5.254
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_198",
    "data-name": "L\\xEDnea 198",
    x2: 18.976,
    transform: "translate(203.986 59.895)",
    fill: "none",
    stroke: "#ffbda4",
    strokeWidth: 5.254
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4716",
    "data-name": "Trazado 4716",
    d: "M343.678,47.225A10.675,10.675,0,1,1,333,36.55a10.675,10.675,0,0,1,10.674,10.675",
    transform: "translate(-119.529 -13.554)",
    fill: "#fff6ec"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultRequest);
export default __webpack_public_path__ + "static/media/NoResultRequest.5e580eaefe09a639b2b0c05951a2d084.svg";
export { ForwardRef as ReactComponent };